module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABOklEQVQ4jbWVMU7DQBBFvxOFyh2ioqKjoOYY3AAJJSJpOQB3oESiQAJfAIqEnpPQIYILGoQESA+NtVYsz27sIHjSFt6Z+Z61Z2YFxFYOzIAFsGTFCzAHpsHHxboNYAKUdPMKjNcJbgFFD6E2NyHWCf5GrKZoC06cy+aMa8E88c3egGvg01nimEau8MfafAP7Ifuj8NyHqUIZtCkb33YEPDuPOAuF2opxGAQPIrYUSyUMxiOQBdFLZ02wTtA4Dz7DvmWVVWlKO0ozk3QlKZN0Kmko6SPsjVpR1ZEf3Gs8Z5EWPXFeMB9IukvmtuJCUtE6ya7zku6zqhilJ0nbzux5tyBJX5KOJQ0aHqWkvX9pvb8YDjZxouPLDJtymxpf9bLUbXh20Tlgm8smkA0N6/Nma9p1YGVm14O/AkA/0Rv6P07431MAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/call_icon20.png
// module id = 250
// module chunks = 0